// AddIncome.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AddIncome.css';
import { useDispatch, useSelector } from 'react-redux';
import { addIncome } from '../../store/incomeSlice'; // Import addIncome thunk
import { fetchIncomes } from '../../store/incomeSlice';
import { INCOME_TAX_HEAD_OPTIONS } from '../../constants/taxOptions';

const AddIncome = () => {
  const { clientId, financialYear } = useSelector((state) => state.app);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [amount, setAmount] = useState('');
  const [taxHead, setTaxHead] = useState('OTHER_SOURCES');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newIncome = { name, description, amount, taxHead, clientId, financialYear };
    
    try {
      await dispatch(addIncome(newIncome)).unwrap(); // Dispatch addIncome action and wait for it to complete
      dispatch(fetchIncomes());
      navigate('/list-income'); // Navigate to income list after successful addition
    } catch (err) {
      console.error('Error adding income', err);
      setError('Error adding income.'); // Set error message if the action fails
    }
  };

  return (
    <div className="add-income-page">
      <h2>Add Income</h2>
      <p className="financial-page-subtitle">Classify manual income lines by tax head so tax computation does not depend on free-text naming.</p>
      <form onSubmit={handleSubmit}>
        <label>
          Tax Head:
          <select
            value={taxHead}
            onChange={(e) => setTaxHead(e.target.value)}
            required
          >
            {INCOME_TAX_HEAD_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>
        <label>
          Particular / Label:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>
        <label>
          Description:
          <input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </label>
        <label>
          Amount:
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
          />
        </label>
        {error && <p className="financial-message financial-message--error">{error}</p>}
        <button type="submit" className="add-income-button">Add Income</button>
      </form>
    </div>
  );
};

export default AddIncome;
